import { AsyncPipe, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ResponsiveService } from '../../services/reponsive.service';
import { Observable } from 'rxjs/internal/Observable';
import { NavbarComponent } from "../../components/navbar/navbar.component";

@Component({
  selector: 'app-privacy-policy',
  imports: [TranslateModule, NgClass, AsyncPipe, NavbarComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './terms-and-privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {

  smallScreen$: Observable<boolean> = this.responsiveService.small$;
  mediumScreen$: Observable<boolean> = this.responsiveService.desktop$;
  largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;

  constructor(
    private responsiveService: ResponsiveService,
  ) { }
}
